import { useMutation, useQueryClient } from "react-query";
import ENDPOINTS from "../../services/endPoints";
import { Auth } from "../../interface";
import { mutatePutFn } from "../../services/networking.service";

export const useUpdateBoxStatus = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutatePutFn(ENDPOINTS.UPDATE_BOX_STATUS, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([]);
      },
    }
  );
};
